import bonniePic from "@/public/images/artists/bonnie.png";
import { Artist } from "@/types/types";

export const bonnie = {
  id: "163",
  name: "Bonnie",
  image: bonniePic,
  description: `Bonnie's voice has a mature edge with a subtle, gritty tone. Her vocals are smooth and controlled, yet retain the right amount of sharpness to add depth and character.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fbonnie-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Pop", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 56,
        high: 68,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
